module.exports = __webpack_public_path__ + "static/media/Kelp_Fronds.b30aff43.webp";